import React from 'react';
import LazyLoad from '../../services/lazyLoad';
const EZSearch = LazyLoad({ loader: () => import('./EZSearch') });

export default function EZSearchWrapper() {
  return <EZSearch />;
}
